import Highlight from "@tiptap/extension-highlight";
import { EditorContent, useEditor } from "@tiptap/react";
import Tiptap from "components/Tiptap";
import Spinner from "components/utils/Spinner";
import useMetaManager from "hooks/useMetaManager";
import { Payment } from "utils/types";
import Paragraph from "@tiptap/extension-paragraph";
import Document from "@tiptap/extension-document";
import History from "@tiptap/extension-history";
import Text from "@tiptap/extension-text";



const AdminData = () => {
  const {
    data: meta,
    intentData: intentMeta,
    loaded: metaLoading,
    isPosting: metaIsPosting,
  } = useMetaManager<Payment.Meta>({
    getUrl: "/payment/meta",
    postUrl: "/payment/meta",
    initialData: {
      accountNumber: "",
      accountName: "",
      bankName: "",
      phoneNumber: "",
    },
  });

  return (
    <div className="flex flex-col relative gap-6">
      <div className="shadow-sm bg-white rounded-md p-4 relative flex flex-col gap-2">
        <h2 className="text-2xl text-gray-700">Payment Data</h2>
        <div className="absolute top-4 right-4 shadow-sm grid place-content-center text-2xl" title="changes saved">
            { (metaIsPosting) ? 
                <i className="fas fa-cloud-arrow-up text-blue-500 "></i> 
              : <i className="fas fa-cloud text-gray-500"></i>
            }
          </div>
        <hr className="my-2" />
        <div className="flex flex-col gap-4">
          {metaLoading ? (
            <Spinner />
          ) : (
            <>
              <div className="flex flex-col gap-2">
                <h3 className="text-xl text-gray-700">Account Name</h3>
                <TipTap
                  text={meta.accountName}
                  onUpdate={(html) =>
                    html != "" && intentMeta((prev) => {
                      prev.accountName = html;
                      return prev;
                    }, "accountName")
                  }
                />
              </div>

              <hr className="mt-2" />
              <div className="flex flex-col gap-2">
                <h3 className="text-xl text-gray-700">Account number</h3>
                <TipTap
                  text={meta.accountNumber}
                  onUpdate={(html) =>
                    html != "" && intentMeta((prev) => {
                      prev.accountNumber = html;
                      return prev;
                    }, "accountNumber")
                  }
                />
              </div>

              <hr className="mt-2" />
              <div className="flex flex-col gap-2">
                <h3 className="text-xl text-gray-700">Bank Name</h3>
                <TipTap
                  text={meta.bankName}
                  onUpdate={(html) =>
                    html != "" && intentMeta((prev) => {
                      prev.bankName = html;
                      return prev;
                    }, "bankName")
                  }
                />
              </div>

              <hr className="mt-2" />
              <div className="flex flex-col gap-2">
                <h3 className="text-xl text-gray-700">Admin phone</h3>
                <TipTap
                  text={meta.phoneNumber}
                  onUpdate={(html) =>
                    html != "" && intentMeta((prev) => {
                      prev.phoneNumber = html;
                      return prev;
                    }, "phoneNumber")
                  }
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminData;

type TipTapProps = {
  text?: string;
  onUpdate: (html: string) => void;
  className?: string;
};
const TipTap = ({ text = "", onUpdate, className }: TipTapProps) => {
  const editor = useEditor({
    extensions: [Document, Paragraph, Text, History, Highlight],
    content: text,
    onUpdate: ({ editor }) => {
      onUpdate(editor.getText());
    },
  });
  return (
    <div className="flex flex-col gap-2">
      <div
        onClick={() => editor?.commands.focus("end")}
        className={
          "cursor-text p-2 border-gray-400 border w-fit rounded-md min-h-[2rem] min-w-[10rem] " +
          className
        }
      >
        <div onClick={(e) => e.stopPropagation()}>
          <EditorContent editor={editor} />
        </div>
      </div>
    </div>
  );
};